import { render, staticRenderFns } from "./AllotteesCMS.vue?vue&type=template&id=740764c3&scoped=true"
import script from "./AllotteesCMS.vue?vue&type=script&lang=js"
export * from "./AllotteesCMS.vue?vue&type=script&lang=js"
import style0 from "./AllotteesCMS.vue?vue&type=style&index=0&id=740764c3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "740764c3",
  null
  
)

export default component.exports